export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_lemon.bbcae9e4.jpg";